import React, { useEffect, useState } from 'react'
import { Form, Select } from 'antd';
import { useKehuyhzhListQuery } from '../../store/DianShangYeWuApi';

function ClientBankSelect(props) {
    const [list,setList] = useState();
    const { data, isSuccess } = useKehuyhzhListQuery(
        { khyhzh_kh_id: props.kh_id },
        { skip: !props.kh_id, refetchOnMountOrArgChange: true }
    );
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {khyhzh_id,khyhzh_name,khyhzh_bank,khyhzh_code}=item;
                    return item = {value:khyhzh_id,label:'户名：'+khyhzh_name+'，开户行：'+khyhzh_bank+'，账号：'+khyhzh_code,key:khyhzh_id}
                })
                setList(newArr)
            }else{
                setList([{value:'',label:'暂无银行账户,请先添加!',key:''}])
            }
        }else{
            setList([{value:'',label:'暂无银行账户,请先添加!',key:''}])
        }
    },[data,isSuccess])
    
    // 如果wrapperCol为null，说明是作为子组件使用，不包装Form.Item
    if (props.wrapperCol === null) {
        return (
            <Select
                options={list} 
                onChange={(_,f) => {
                    if(f){
                        props.onChange(f.value,f.label,)
                    }
                }}
                placeholder={props.placeholder || '请选择客户银行账户'}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
            />
        )
    }

    return (
        <Form.Item 
            label={props.label} 
            required={props.required}  
            style={props.formStyle}
            wrapperCol={props.wrapperCol}
            name={props.name}
        >
            <Select
                options={list} 
                onChange={(_,f) => {
                    if(f){
                        props.onChange(f.value,f.label)
                    }
                }}
                placeholder={props.placeholder || '请选择客户类型'}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
            />                        
        </Form.Item>
    )
}

export default ClientBankSelect
